<mat-card>
  <h2 translate>{{ isUpdate ? 'updateProfile.title' : 'deleteProfile.title' }}</h2>
  <p translate>{{ isUpdate ? 'updateProfile.subtitle' : 'deleteProfile.subtitle' }}</p>
  <mat-card-content>
    <div class="table__wrapper">
      <table aria-label="profileList" mat-table [dataSource]="profileList">
        <ng-container matColumnDef="profile">
          <th mat-header-cell *matHeaderCellDef translate>{{ 'userProfileSingle.profiles' }}</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>
        <ng-container matColumnDef="selection">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="center">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(element) : null"
              [checked]="selection.isSelected(element)"
            >
            </mat-checkbox>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
<div class="delete__actions">
  <button
    id="actionBtn"
    mat-flat-button
    color="accent"
    type="button"
    (click)="sendProfile()"
    [disabled]="!this.selection.hasValue()"
  >
    <mat-label translate>{{ isUpdate ? 'updateProfile.update' : 'deleteProfile.delete' }}</mat-label>
  </button>
</div>
